import api from '../api';

let apiUrl = 'market-symbols';

const state = {
    data: []
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    product: async ({ commit }, config) => {
        return await api
            .get('/api/v1/market-symbol-product', config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, response) {
        if (response.config.params?.page) {
            state.data.meta = response.data.meta;
            state.data.links = response.data.links;
            state.data.data.push(...response.data.data);
        } else {
            state.data = response.data;
        }
    }
};

const getters = {
    all: (state) => {
        return state.data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
